import { HttpClientConfig, type HttpClientInterface } from 'core/infra/http/HttpClient'

import {
  mapApiToOpenDockOrgReportDownload,
  mapApiToOpenDockOrgReports,
  RawOpenDockOrgReport,
  RawOpenDockOrgReportDownload,
} from './OpenDockReportsMapper'

export type OpenDockReportsRepositoryDependencies = {
  httpClient: HttpClientInterface
}

export class OpenDockReportsRepository {
  private httpClient: HttpClientInterface

  constructor({ httpClient }: OpenDockReportsRepositoryDependencies) {
    this.httpClient = httpClient
  }

  async getReports(config?: HttpClientConfig) {
    const { data } = await this.httpClient.get<Array<RawOpenDockOrgReport>>(
      '/opendock_reports',
      config
    )

    try {
      return mapApiToOpenDockOrgReports(data)
    } catch {
      throw new Error('Failed to map API to OpenDock reports')
    }
  }

  async getLatestDownload(config?: HttpClientConfig) {
    const { data } = await this.httpClient.get<RawOpenDockOrgReportDownload>(
      '/opendock_reports/latest/download',
      config
    )

    try {
      return mapApiToOpenDockOrgReportDownload(data)
    } catch {
      throw new Error('Failed to map API to OpenDock report download')
    }
  }

  async getFile(uuid: string, config?: HttpClientConfig) {
    const { data } = await this.httpClient.get<Blob>(`/opendock_reports/${uuid}/file`, {
      ...config,
      responseType: 'blob',
      headers: {
        ...(config?.headers ?? {}),
        Accept: 'application/pdf',
      },
    })

    return data
  }

  async getDownload(uuid: string, config?: HttpClientConfig) {
    const { data } = await this.httpClient.get<RawOpenDockOrgReportDownload>(
      `/opendock_reports/${uuid}/download`,
      config
    )

    try {
      return mapApiToOpenDockOrgReportDownload(data)
    } catch {
      throw new Error('Failed to map API to OpenDock report download')
    }
  }
}
